module.exports = __webpack_public_path__ + "img/logo_with_text_ru.fe7a37d9.png";